import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { UiActionStore } from '../models/ui-action.models';

interface ActionSubscription {
    actionName: string;
    subscription: Subscription;
}

@Injectable({
    providedIn: 'root',
})
export class SubscriptionManagerService {
    private actionSubscriptions: ActionSubscription[] = [];

    UnsubscribeActions(keepActions: UiActionStore[] = []): void {
        //console.warn(`Unsubscribing all actions except: ${keepActions.map(item => this.GetActionFullNameFromUiActionStore(item)).join(", ")}`);
        const keepNames: string[] = keepActions.map((item) => this.GetActionFullNameFromUiActionStore(item));
        const toRemove = this.actionSubscriptions.filter(
            item => !keepNames.includes(item.actionName)
        );
        toRemove.forEach(item => item.subscription.unsubscribe());
        this.actionSubscriptions = this.actionSubscriptions.filter(
            item => keepNames.includes(item.actionName)
        );
    }

    UnsubscribeAllActions(): void {
        //console.warn('Unsubscribing all actions, count: ' + this.actionSubscriptions.length);
        this.actionSubscriptions.forEach(item => item.subscription.unsubscribe());
        this.actionSubscriptions = [];
    }

    UnsubscribeActionsFromPath(path: string): void {
        //console.warn(`Unsubscribing actions from path: ${path}, count: ${this.actionSubscriptions.filter(
        //    item => item.actionName.toLowerCase().startsWith(path.toLowerCase())
        //).length}`);
        const toRemove = this.actionSubscriptions.filter(
            item => item.actionName.toLowerCase().startsWith(path.toLowerCase())
        );
        toRemove.forEach(item => item.subscription.unsubscribe());
        this.actionSubscriptions = this.actionSubscriptions.filter(
            item => !toRemove.includes(item)
        );
    }

    AddSubscription(path: string, actionName: string, subscription: Subscription): void {
        const actionFullName = this.GetActionFullName(path, actionName);

        //console.warn(`Adding subscription for action: ${actionFullName}`);
        if (this.actionSubscriptions.some(item => item.actionName === actionFullName)) {
            var existing = this.actionSubscriptions.find(item => item.actionName === actionFullName);
            existing?.subscription.add(subscription);
        }
        else {
            var newSubscription = new Subscription();
            newSubscription.add(subscription);
            this.actionSubscriptions.push({ actionName: actionFullName, subscription: newSubscription });
        }
    }

    GetActionFullName(path: string, name: string): string {
        var fullName = '';
        if (!path || path === '') {
            fullName = name;
        } else {
            fullName = path + '.' + name;
        }
        //console.log(`Generated full action name: ${fullName} from path: ${path} and name: ${name}`);
        return fullName;
    }

    GetActionFullNameFromUiActionStore(item: UiActionStore): string {
        return this.GetActionFullName(item.path, item.name);
    }

}
